module.exports = __webpack_public_path__ + "img/Sleeves-Front-B9-Da-Eb-Gc.0cc131db.png";